module.exports = __webpack_public_path__ + "img/3-icono-pendientes-selected.f2dd2877.svg";